import api from '@/api/index.js'

const distributors_summary_report = {
  state: {
    loading: false,
    reportData: null,
    error: null
  },


  mutations: {
    DISTRIBUTORS_SUMMARY_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    DISTRIBUTORS_SUMMARY_REPORT: (state, response) => {
      state.reportData = response;
      state.loading = false;
    },
    DISTRIBUTORS_SUMMARY_UPDATE_REPORT: (state, change) => {
      state.reportData.data.forEach((distributor) => {
        if (distributor.distributor_id == change.distributor_id) {
          distributor.unfinished_transactions_count = distributor.unfinished_transactions_count - change.force_cancel_count
        }
      });
    },
    DISTRIBUTORS_SUMMARY_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetDistributorsSummaryReport({commit}, query) {
      let reqQueryStr = '';
      if (query.period.year) {
        reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
      }

      commit('DISTRIBUTORS_SUMMARY_REPORT_ERROR', null)
      commit('DISTRIBUTORS_SUMMARY_REPORT', null)
      commit('DISTRIBUTORS_SUMMARY_REPORT_LOADING', true)
      return api.get('reports/distributors?' + reqQueryStr)
        .then((response) => {
          commit('DISTRIBUTORS_SUMMARY_REPORT', response)
        })
        .catch((error) => {
          commit('DISTRIBUTORS_SUMMARY_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('DISTRIBUTORS_SUMMARY_REPORT_LOADING', false)
        })
    }
  },
}

export default distributors_summary_report
